import { render, staticRenderFns } from "./linkedin.svg.vue?vue&type=template&id=5803e2d0&"
import script from "./linkedin.svg.vue?vue&type=script&lang=js&"
export * from "./linkedin.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports